export const GET_SOURCES_FOR_PROJECT = 'get-data-sources-for-project';
export const GET_DOMAINS_STATS = 'get-domains-stats';
export const GET_TYPES_STATS = 'get-types-stats';
export const GET_DOMAINS_DAILY_STATS = 'get-domains-daily-stats';
export const GET_DOMAINS_WITH_SOURCES_STATS = 'get-domains-with-sources-stats';
export const GET_SOURCES_STATS = 'get-data-sources-stats';
export const GET_KEY_SOURCES_STATS = 'get-key-sources-stats';
export const GET_DOMAINS_INFINITE = 'get-domains-infinite';
export const GET_CATEGORIES_STATS = 'get-categories-stats';
export const GET_SOURCES_DAILY_STATS_FOR_DOMAIN = 'get-sources-daily-stats-for-domain';
export const GET_SOURCES_STATS_FOR_DOMAIN = 'get-sources-stats-for-domain';
export const GET_CHATS_FOR_DOMAIN = 'get-chats-for-domain';
